"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _detectOTPFunctionality = require("./detectOTPFunctionality");

var _excluded = ["containerClassName", "childClassName", "length", "onChange", "otpAutoReadSuccess", "otpAutoReadFailure", "otpDetectionInterval", "otpAutoReadTimeout"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var OTPWithAutoRead = function OTPWithAutoRead(_ref) {
  var containerClassNameProp = _ref.containerClassName,
      childClassNameProp = _ref.childClassName,
      length = _ref.length,
      onChange = _ref.onChange,
      otpAutoReadSuccess = _ref.otpAutoReadSuccess,
      otpAutoReadFailure = _ref.otpAutoReadFailure,
      otpDetectionInterval = _ref.otpDetectionInterval,
      otpAutoReadTimeout = _ref.otpAutoReadTimeout,
      inputProps = _objectWithoutProperties(_ref, _excluded);

  var containerClassName = (0, _clsx["default"])("otp-code", containerClassNameProp);
  var childClassName = (0, _clsx["default"])("otp-flds", childClassNameProp);

  var _useState = (0, _react.useState)(new Array(length).fill("")),
      _useState2 = _slicedToArray(_useState, 2),
      otpInput = _useState2[0],
      setOtpInput = _useState2[1];

  var otpRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    // functionality to auto-read the OTP from browser
    (0, _detectOTPFunctionality.detectOTPFunctionality)(function (otp) {
      // prop based function
      onChange(otp);
      otpAutoReadSuccess();
    }, function (err) {
      otpAutoReadFailure(err);
    }, otpDetectionInterval, function () {
      otpAutoReadTimeout();
    });
  }, []);

  var handleOtpKeyDown = function handleOtpKeyDown(e, index) {
    if (index > 0) {
      (e.key === "Backspace" || e.key === "Delete") && otpInput[index].length == 0 ? document.getElementById(index - 1).focus() : e.target.select();
    }
  };

  var handleOtpChange = function handleOtpChange(element, index) {
    if (isNaN(element.value)) return false;

    var tempArr = _toConsumableArray(otpInput);

    tempArr[index] = element.value;
    setOtpInput(tempArr); // prop based function

    onChange(otpInput.join(""));

    if (element.value.length > 0 && index < otpInput.length - 1) {
      document.getElementById(index + 1).focus();
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: containerClassName
  }, otpInput.map(function (data, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: childClassName
    }, /*#__PURE__*/_react["default"].createElement("input", _extends({
      type: "numeric",
      name: "",
      maxLength: "1",
      id: index,
      value: data,
      onChange: function onChange(e) {
        return handleOtpChange(e.target, index);
      },
      onKeyDown: function onKeyDown(e) {
        handleOtpKeyDown(e, index);
      },
      ref: otpRef
    }, inputProps)));
  }));
};

OTPWithAutoRead.propTypes = {
  containerClassName: _propTypes["default"].string,
  childClassName: _propTypes["default"].string,
  length: _propTypes["default"].number.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  otpAutoReadSuccess: _propTypes["default"].func,
  otpAutoReadFailure: _propTypes["default"].func,
  otpDetectionInterval: _propTypes["default"].number,
  otpAutoReadTimeout: _propTypes["default"].func.isRequired
};
OTPWithAutoRead.defaultProps = {
  containerClassName: "otp-code",
  childClassName: "otp-flds",
  length: 4,
  onChange: function onChange() {},
  otpAutoReadSuccess: function otpAutoReadSuccess() {},
  otpAutoReadFailure: function otpAutoReadFailure() {},
  otpDetectionInterval: 60,
  otpAutoReadTimeout: function otpAutoReadTimeout() {}
};
var _default = OTPWithAutoRead;
exports["default"] = _default;